import React from "react";
import { motion } from "framer-motion";
import { TESTIMONIALS } from "../data/content";
import { Quote } from "lucide-react";

export default function Testimonials() {
  return (
    <section
      className="relative py-14 md:py-28 bg-[#0F1B47] overflow-hidden"
      data-testid="testimonials-section"
    >
      {/* Decorative shapes */}
      <div className="absolute top-10 right-10 w-40 h-40 rounded-full bg-[#648DE5]/15" />
      <div className="absolute bottom-10 left-10 w-24 h-24 rounded-full bg-[#C6D947]/20" />
      <div
        className="absolute top-1/2 left-1/3 shape-square opacity-10"
        style={{ width: 120, height: 120, background: "#5BC4B8" }}
      />

      <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
        <div className="max-w-2xl mb-14">
          <span className="text-xs font-bold tracking-[0.22em] uppercase text-[#C6D947] mb-5 block">
            Parents, in their own words
          </span>
          <h2 className="font-display text-[#FDFDF9] text-[32px] md:text-5xl lg:text-6xl leading-[1.05] tracking-tight font-semibold">
            The stories we're
            <br />
            most <span className="italic font-normal">proud</span> of.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="bg-[#FDFDF9]/5 backdrop-blur-sm border border-[#FDFDF9]/10 rounded-3xl p-8"
              data-testid={`testimonial-${i}`}
            >
              <Quote size={32} className="text-[#C6D947] mb-5" />
              <p className="text-[#FDFDF9] text-lg leading-relaxed font-light font-display italic">
                "{t.quote}"
              </p>
              <div className="mt-6 pt-5 border-t border-[#FDFDF9]/10">
                <div className="text-[#FDFDF9] font-semibold text-sm">{t.name}</div>
                <div className="text-[#FDFDF9]/60 text-xs mt-0.5">{t.role}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
